import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-digital',
  templateUrl: './digital.component.html',
  styleUrls: ['./digital.component.css','../../categories.component.css']
})
export class DigitalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
